import { useState } from "react";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import "./authForm.scss";
import { Link, useNavigate } from "react-router-dom";
import LoadingSpinner from "../../components/loader/Loader";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { setCredentials } from "../../features/auth/authSlice";
import { useLoginMutation } from "../../features/api/authApiSlice";

import { useRecaptcha, executeRecaptcha } from "../../hooks/useRecaptcha";

const SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY;

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [login, { isLoading }] = useLoginMutation();
  const [formData, setFormData] = useState({
    identifier: "",
    password: "",
    rememberMe: false,
  });

  useRecaptcha(SITE_KEY, ["/login"]); // ✅ only show badge on /login

  const isFormValid =
    formData.identifier.trim() !== "" && formData.password.trim() !== "";

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const token = await executeRecaptcha(SITE_KEY, "login");

      // ✅ Send token along with login data
      const res = await login({
        ...formData,
        recaptchaToken: token,
      }).unwrap();

      dispatch(
        setCredentials({
          accessToken: res.accessToken,
          user: res.user,
        })
      );

      navigate("/");
      toast.success(res?.message || "Login successful!");
    } catch (err) {
      const status = err?.status;
      if (status === 401 || status === 403) {
        toast.error(
          err?.data?.message || "Invalid credentials or email not verified."
        );
      } else if (status === 500) {
        toast.error("Server error. Please try again later.");
      } else {
        toast.error(err?.data?.message || "Login failed.");
      }
    }
  };

  return (
    <div className="auth-form">
      <div className="main">
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <div className="auth-from-container">
            <h2>Account Login</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="identifier">Email or Username</label>
                <input
                  id="identifier"
                  name="identifier"
                  onChange={handleChange}
                  placeholder="Enter your email or username"
                  value={formData.identifier}
                />
              </div>

              <div className="password-input-wrapper">
                <div className="form-group">
                  <label htmlFor="password">Password</label>
                  <input
                    id="password"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    onChange={handleChange}
                    placeholder="Password"
                    value={formData.password}
                  />
                </div>
                <button
                  type="button"
                  className="toggle-password"
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? <FiEye /> : <FiEyeOff />}
                </button>
              </div>
              {/* <div className="form-controls">
                <Checkbox
                  id="keepMeSignedIn"
                  label="Keep me signed in"
                  checked={formData.rememberMe}
                  onChange={(e) =>
                    setFormData({ ...formData, rememberMe: e.target.checked })
                  }
                />
              </div> */}
              <div className="auth-form-links">
                <p>
                  Forgot My Password?{" "}
                  <Link to="/forgotpassword">Forgot Password</Link>
                </p>
                <p>
                  Not a Member yet? <Link to="/member">Become A Member</Link>
                </p>

                {/* This verification email is working we are just not using it */}
                {/* <p>
                  Didn’t receive a verification email?{" "}
                  <Link to="/resend-verification">Resend here</Link>
                </p> */}
              </div>
              <button type="submit" disabled={!isFormValid || isLoading}>
                Login
              </button>
            </form>
            <div className="divider">or</div>
            <button
              className="otp-login"
              style={{ marginBottom: "18px" }}
              onClick={() => navigate("/otplogin")}
            >
              OTP Sign In
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Login;
